/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerMiniCartBadgeSX: SxProps = {
	'.MuiBadge-badge': {
		color: '#000000',
		backgroundColor: '#4ead33',
	},
};
